import { getActualMap } from "./globalContext";

const accordionMenue = document.getElementsByClassName("accordion-new");

/**
 * Funktion um die Legende upzudaten
 *
 */
export const updateLegend = function (resolution) {
  // Alle layer der Karte holen
  const map = getActualMap();
  const actualMap = map.globalMap.getLayers();

  // Nur sichtbare filtern
  let visibleWMSLayer = [];
  actualMap.array_.forEach(function (key, value) {
    if (key != undefined) {
      if (key.state_ != undefined) {
        if (key.state_.visible != undefined) {
          if (key.state_.visible) {
            visibleWMSLayer.push(key.values_.source);
          }
        }
      }
    }
    /*
      if (
        key === undefined ||
        key.state_ === undefined ||
        key.state_.visible === undefined
      ) {
        console.log("Cant Update");
      } else {
        visibleWMSLayer.push(key.values_.source);
      }*/
  });

  // URL und Layernamen für Legende zusammenbauen
  let legendImangeUrls = [];
  let legendImageDescription = [];

  visibleWMSLayer.forEach(function (key, value) {
    if (key.params_ != undefined) {
      if (key.params_.LAYERS != undefined) {
        legendImangeUrls.push(key.getLegendUrl());
        legendImageDescription.push(key.params_.ownName);
      }
    }
  });

  // Legenden in DIV schreiben
  let mapLayerLegendDIV = document.getElementById("mapLayerLegendContainer");
  mapLayerLegendDIV.innerHTML = "";

  legendImangeUrls.forEach(function (key, value) {
    //Überschrift erstllen
    var h = document.createElement("H3");
    var t = document.createTextNode(legendImageDescription[value]);
    var hr = document.createElement("hr");
    h.appendChild(t);

    //Image erstllen
    let img = document.createElement("img");
    img.src = key;

    // in Website einfügen
    mapLayerLegendDIV.appendChild(h);
    mapLayerLegendDIV.appendChild(hr);
    mapLayerLegendDIV.appendChild(img);
  });
};

export function zuruecksetzenLiveSuche() {
  // Zuruecksetzen Anzahl gefundener Baeume
  const searchResultCountBadge = document.getElementById(
    "liveSearchResultCount"
  );
  searchResultCountBadge.innerHTML = "Anzahl gefundener Bäume : 0";
  // Zuruecksetzen Anzeige gefundener Baeume
  // TODO: Besprechen mit MARC
  const livesearchBox = document.getElementById("livesearch");
  livesearchBox.innerHTML = "";
  livesearchBox.style.border = "0px";
  livesearchBox.style.display = "none";

  const mehrSuchergebnisse = document.getElementById("mehrSuchergebnisse");
  mehrSuchergebnisse.setAttribute("hidden", true);
}

export function zuruecksetzenLiveSucheFlaechen() {
  // Zuruecksetzen Anzahl gefundener Flaechen
  const anzahlGefundenerFlaechen = document.getElementById(
    "anzahlGefundenerFlaechen"
  );
  anzahlGefundenerFlaechen.innerHTML = "Anzahl gefundener Flächen : 0";
  // Zuruecksetzen Anzeige gefundener Baeume
  const livesearchFlaechen = document.getElementById("livesearchFlaechen");
  livesearchFlaechen.innerHTML = "";
  livesearchFlaechen.style.border = "0px";
  livesearchFlaechen.style.display = "none";
}

/**
 * Accordion Logik
 *
 */
export function erstelleAccordionListener() {
  for (let i = 0; i < accordionMenue.length; i++) {
    accordionMenue[i].addEventListener("click", function () {

      closeOtherPanels(this);

      this.classList.toggle("active");

      /* Toggle between hiding and showing the active panel */
      var panel = this.nextElementSibling;
      panel;
      if (panel.style.display === "block") {
        panel.style.display = "none";
      } else {
        panel.style.display = "block";
      }
    });
  }
}

function closeOtherPanels(clickedElement) {
  for (let i = 0; i < accordionMenue.length; i++) {
    if (accordionMenue[i] !== clickedElement) {
      // Remove "active" class from other accordion buttons
      accordionMenue[i].classList.remove("active");

      // Hide the corresponding panels
      var otherPanel = accordionMenue[i].nextElementSibling;
      otherPanel.style.display = "none";
    }
  }
}
